/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: "/Traineehome",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    i18n: "Home",
  },
  {
    url: "/CustomerHome",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    i18n: "Home",
  },
  {
    url: "/InstructorHome",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    i18n: "Home",
  },
  {
    url: "/home",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    i18n: "Home",
  },
  {
    url: "/Diplomas",
    name: "Diplomas",
    slug: "Diplomas",
    icon: "CreditCardIcon",
    i18n: "Diplomas",
  },
  // {
  //   url: "/CustomerCourseRequest",
  //   name: "CustomerCourseRequest",
  //   slug: "CustomerCourseRequest",
  //   icon: "TrelloIcon",
  //   i18n: "Course Request",
  // },
  // {
  //   url: "/TraineeOfCustomer",
  //   name: "TraineeOfCustomer",
  //   slug: "TraineeOfCustomer",
  //   icon: "UsersIcon",
  //   i18n: "My Trainees",
  // },
  {
    url: "/InstructorSchedule",
    name: "InstructorSchedule",
    slug: "Instructor Schedule",
    icon: "TrelloIcon",
    i18n: "Schedule",
  },
  {
    url: "/InstructorTraineeAttendance",
    name: "InstructorTraineeAttendance",
    slug: "TraineeAttendance",
    icon: "UserCheckIcon",
    i18n: "TraineeAttendance",
  },
  {
    url: '/TraineeParticipation',
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'instructor'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'evaluator',
    name: "TraineeParticipation",
    slug: "TraineeParticipation",
    icon: "UserCheckIcon",
    i18n: "TraineeParticipation",
  },
  {
    url: "/InstructorMarkExam",
    name: "InstructorMarkExam",
    slug: "InstructorMarkExam",
    icon: "EditIcon",
    i18n: "MarkExam",
  },
  {
    url: "/TraineeCoursesInstructor",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'instructor'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'evaluator',
    name: "TraineeCoursesInstructor",
    slug: "TraineeCoursesInstructor",
    icon: "PercentIcon",
    i18n: "PracticalDegrees",
  },
  {
    url: "/InstructorCourseEvaluation",
    name: "InstructorCourseEvaluation",
    slug: "InstructorCourseEvaluation",
    icon: "SmileIcon",
    i18n: "TraineeFeedback",
  },
  {
    url: "/TraineeCoursesPass",
    name: "TraineeCoursesPass",
    slug: "TraineeCoursesPass",
    icon: "UserCheckIcon",
    i18n: "TraineeCoursesPass",
  },
  {
    url: "/Schedule",
    name: "Schedule",
    slug: "Schedule",
    icon: "TrelloIcon",
    i18n: "Schedule",
  },
  {
    url: '/Course',
    name: "Course",
    slug: "Course",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
      JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator' ||
      JSON.parse(localStorage.getItem("userInfo")).userRole == 'Coordinator',
      // mkl
    icon: "ColumnsIcon",
    i18n: "CourseCatalog",
  },
  {
    url: '/CourseTrack',
    name: "CourseTrack",
    slug: "CourseTrack",
    icon: "CreditCardIcon",
    i18n: "Diplomas",
  },
  {
    url: '/CourseMaterial',
    name: "CourseMaterial",
    slug: "CourseMaterial",
    icon: "DownloadIcon",
    i18n: "CourseMaterial",
  },
  {
    url: '/AvailableExam',
    name: "AvailableExam",
    slug: "AvailableExam",
    icon: "FileTextIcon",
    i18n: "YourExams",
  },
  {
    url: '/AvailableReview',
    name: "AvailableReview",
    slug: "AvailableReview",
    icon: "SmileIcon",
    i18n: "CourseFeedback",
  },
  {
    url: '/AvailableInstructorReview',
    name: "AvailableInstructorReview",
    slug: "AvailableInstructorReview",
    icon: "SmileIcon",
    i18n: "CourseInstructorFeedback",
  },
  {
    url: '/ExamResult',
    name: "ExamResult",
    slug: "ExamResult",
    icon: "PercentIcon",
    i18n: "ExamResult",
  },
  // {
  //   url: '/RequestCourseClass',
  //   name: "RequestCourseClass",
  //   slug:"RequestCourseClass",
  //   icon: "CreditCardIcon",
  //   i18n: "Course Request",
  // },


  //start coordinator
  {
    url: '/planning',
    name: "Planning",
    slug: "Planning",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
      JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    // mkl
    // tag: "2",
    // tagColor: "primary",
    icon: "TrelloIcon",
    i18n: "Planning",
    submenu: [
      {
        url: "/Planning/Holiday",
        name: "Holiday",
        slug: "Holiday",
        icon: "calendar",
        i18n: "Holiday",
      },
      {
        url: "/Planning/AnnualPlan",
        name: "Annual Plan",
        slug: "Annual Plan",
        icon: "calendar",
        i18n: "AnnualPlan",
      },
      {
        url: "/Planning/YearSummary",
        name: "Year Summary",
        slug: "Year Summary",
        icon: "calendar",
        i18n: "YearSummary",
      },
      {
        url: "/Planning/RoomPlan",
        name: "Year Summary",
        slug: "Room Plan",
        icon: "calendar",
        i18n: "RoomPlan",
      },
    ]
  },
  {
    url: '/advertisement',
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin',
    // || JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    name: "advertisement",
    slug: "advertisement",
    icon: "RadioIcon",
    i18n: "advertisement",
  },
  {
    url: null,
    name: "Enrollment Management",
    // tag: "2",
    // tagColor: "primary",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
      JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
      //  mkl
    icon: "UsersIcon",
    i18n: "EnrollmentManagement",
    submenu: [
      {
        url: '/CourseRequest',
        name: "CourseRequest",
        slug: "CourseRequest",
        icon: "CreditCardIcon",
        i18n: "CourseRequest",
      },
      {
        url: '/MainCourseRegistration',
        name: "CourseRegistration",
        slug: "CourseRegistration",
        icon: "CreditCardIcon",
        i18n: "CourseRegistration",
      },
    ]
  },
  {
    url: '/CourseClass',
    name: "CourseClass",
    slug: "CourseClass",
    // tag: "2",
    // tagColor: "primary",
    icon: "ClipboardIcon",
    i18n: "CourseClass",
  },



  {
    url: '/FollowRegistration',
    name: "FollowRegistration",
    slug: "FollowRegistration",
    icon: "RssIcon",
    i18n: "FollowRegistration",
  },
  {
    url: '/FollowCourseRequest',
    name: "FollowCourseRequest",
    slug: "FollowCourseRequest",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole != 'admin' &&
      JSON.parse(localStorage.getItem("userInfo")).userRole != 'trainingcoordinator',
    icon: "EditIcon",
    i18n: "FollowCourseRequest",
  },
  {
    url: '/TraineeCertification',
    name: "TraineeCertification",
    slug: "TraineeCertification",
    icon: "AwardIcon",
    i18n: "TraineeCertification",
  },

  {
    url: '/Instructor',
    name: "Instructor",
    slug: "Instructor",
    // tag: "2",
    // tagColor: "primary",
    icon: "UsersIcon",
    i18n: "Instructor",
  },
  // InstructorAssessment
  {
    url: null,
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'evaluator',
    name: "Customer Review",
    icon: "CheckSquareIcon",
    i18n: "InstructorAssessment",
    submenu: [
      {
        url: "/Question/AssessmentInstructorQuestion",
        name: "AssessmentInstructorQuestion",
        slug: "AssessmentQuestion",
        icon: "hard-drive",
        i18n: "AssessmentQuestion",
      },
      {
        url: "/CustomerReview/InstructorAssessment",
        name: "InstructorReview",
        slug: "AssessmentCreation",
        icon: "hard-drive",
        i18n: "AssessmentCreation",
      },
      {
        url: '/InstructorAssessment',
        name: "InstructorAssessment",
        slug: "AssessmentProcess",
        icon: "HelpCircleIcon",
        i18n: "AssessmentProcess",
      },
      {
        url: '/InstructorAssessmentResult',
        name: "InstructorAssessmentResult",
        slug: "AssessmentResult",
        icon: "UserCheckIcon",
        i18n: "AssessmentResult",
      },
    ]
  },
  // TraineeFollow
  {
    url: null,
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
      // mkl
    name: "Customer Review",
    icon: "UserCheckIcon",
    i18n: "TraineeFollow",
    submenu: [
      {
        url: '/TraineeAttendance',
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
          JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
          // mkl
        name: "TraineeAttendance",
        slug: "TraineeAttendance",
        icon: "UserCheckIcon",
        i18n: "TraineeAttendance",
      },
      {
        url: '/TraineeParticipation',
        name: "TraineeParticipation",
        slug: "TraineeParticipation",
        icon: "UserCheckIcon",
        i18n: "TraineeParticipation",
      },
      {
        url: '/TraineeExamsAnswers',
        name: "TraineeExamsAnswers",
        slug: "TraineeExamsAnswers",
        icon: "Edit3Icon",
        i18n: "TraineeExamsAnswers",
      },
    ]
  },
  {
    url: null,
    name: "Question",
    icon: "HelpCircleIcon",
    i18n: "ExaminationManagement",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    submenu: [
      // {
      //   url: "/Setting/Category",
      //   name: "CategoryQuestion",
      //   slug: "Category",
      //   icon: "GridIcon",
      //   i18n: "Question Category"
      // },
      {
        url: "/Question/QuestionBank/ListOfCourses",
        name: "ListOfCourses",
        slug: "ListOfCourses",
        icon: "hard-drive",
        i18n: "QuestionBank",
      },
      {
        url: '/CourseExam',
        name: "Course Exam",
        slug: "Course Exam",
        icon: "CreditCardIcon",
        i18n: "ExamRule",
      },
      {
        url: '/ExamGeneration',
        name: "ExamGeneration",
        slug: "ExamGeneration",
        icon: "CreditCardIcon",
        i18n: "ExamGeneration",
      }
    ]
  },

  {
    url: null,
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    name: "Practical Examination",
    icon: "TrelloIcon",
    i18n: "PracticalExamination",
    submenu: [
      {
        url: "/PracticalExamination/GeneralPracticalQuestion",
        name: "GeneralPracticalQuestion",
        slug: "GeneralPracticalQuestion",
        icon: "hard-drive",
        i18n: "PracticalEvaluationQuestion",
      },
      // {
      //   url: "/PracticalExamination/CoursePracticalQuestion",
      //   name: "CoursePracticalQuestion",
      //   slug: "CoursePracticalQuestion",
      //   icon: "hard-drive",
      //   i18n: "Course Practical Question",
      // },
      {
        url: "/PracticalExamination/PracticalProcess",
        name: "PracticalProcess",
        slug: "PracticalProcess",
        icon: "hard-drive",
        i18n: "PracticalProcess",
      },
    ]
  },

  {
    url: null,
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
      || JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    name: "Customer Review",
    icon: "RssIcon",
    i18n: "Feedback",
    // mkl
    submenu: [
      {
        url: "/Question/AssessmentCourseQuestion/ListOfCategoryAssessment",
        name: "AssessmentCourseQuestion",
        slug: "AssessmentCourseQuestion",
        icon: "hard-drive",
        i18n: "FeedbackQuestion",
      },
      {
        url: "/CustomerReview/CourseReview",
        name: "CourseReview",
        slug: "CourseReview",
        icon: "hard-drive",
        i18n: "CourseFeedback",
      },

    ]
  },

  {
    url: "/Reports",
    name: "Reports  ",
    slug: "Reports",
    icon: "TrendingUpIcon",
    i18n: "RecordsReports"
  },

  {
    url: null,
    name: "Dashboard",
    show: JSON.parse(localStorage.getItem("userInfo")).userRole != 'Trainee' &&
      JSON.parse(localStorage.getItem("userInfo")).userRole != 'Instructor' &&
      JSON.parse(localStorage.getItem("userInfo")).userRole != 'Customer',
    // show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
    // || JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    //show: true,
    // tag: "2",
    // tagColor: "primary",
    icon: "BarChart2Icon",
    i18n: "Dashboard",
    submenu: [
      // {
      //   url: '/dashboard/analytics',
      //   name: "Analytics",
      //   slug: "dashboard-analytics",
      //   i18n: "Analytics",
      // },
      {
        url: '/Statistics/Assessment',
        name: "Assessment",
        slug: "Feedback",
        i18n: "Feedback",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'

      },
      {
        url: '/InstructorsFeedBack',
        name: "InstructorsFeedBack",
        slug: "InstructorsFeedBack",
        icon: "SmileIcon",
        i18n: "InstructorsFeedBack",

      },
      {
        url: '/Statistics/QuestionPassStatistics',
        name: "PassStatistics",
        slug: "PassStatistics",
        i18n: "QuestionPassStatistics",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'

      },
      {
        url: '/Statistics/CoursePassStatistics',
        name: "CoursePassStatistics",
        slug: "CoursePassStatistics",
        i18n: "CoursePassStatistics",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'

      },
      {
        url: '/LogActions/LogAction',
        name: "LogActions",
        slug: "LogActions",
        i18n: "LogActions",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'
      },
      {
        url: '/FeedbackAction/FeedbackAction',
        name: "FeedbackAction",
        slug: "FeedbackAction",
        icon: "TrelloIcon",
        i18n: "FeedbackAction",
      },
    ]
  },
  // {
  //   url: '/FeedbackAction/FeedbackAction',
  //   name: "FeedbackAction",
  //   icon: "BarChart2Icon",
  //   i18n: "FeedbackAction",
  //   show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
  //                                                                  //'trainingcoordinator'
  //   //JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin'   ||
  // },





  {
    url: null,
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
      JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
    name: "Users",
    // tag: "1",
    // tagColor: "primary",
    icon: "UserIcon",
    i18n: "Users",
    submenu: [
      {
        url: "/user",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin',
        name: "UserManagement",
        slug: "user management",
        icon: "GridIcon",
        i18n: "UserManagement",
      },
      {
        url: "/User/Organization",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
          JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
        name: "Organization",
        slug: "Organizations",
        icon: "GridIcon",
        i18n: "Organizations",
      },
      {
        url: "/User/Trainee",
        show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin' ||
          JSON.parse(localStorage.getItem("userInfo")).userRole == 'trainingcoordinator',
        name: "Trainee",
        slug: "Trainee",
        icon: "GridIcon",
        i18n: "Trainees",
      },
    ]
  },
  {
    url: null,
    show: JSON.parse(localStorage.getItem("userInfo")).userRole == 'admin',
    name: "Setting",
    // tag: "4",
    // tagColor: "primary",
    icon: "SettingsIcon",
    i18n: "Setting",
    submenu: [
      {
        url: "/Setting/AdditionalFacility",
        name: "Additional Services",
        slug: "AdditionalFacility",
        icon: "GridIcon",
        i18n: "AdditionalServices"
      },
      {
        url: "/Setting/AdvertisementEmail",

        name: "AdvertisementEmail",
        slug: "AdvertisementEmail",
        icon: "GridIcon",
        i18n: "AdvertisementEmail"
      },
      {
        url: "/Setting/AnnualCalender",
        name: "AnnualCalender",
        slug: "AnnualCalender",
        icon: "GridIcon",
        i18n: "AnnualCalender"
      },
      {
        url: "/Setting/CourseAreaOfStudy",
        name: "CourseAreaOfStudy",
        slug: "CourseAreaOfStudy",
        icon: "GridIcon",
        i18n: "AreaOfStudy"
      },
      // {
      //   url: "/Setting/AssessmentType",
      //   name: "Assessment Type",
      //   slug: "AssessmentType",
      //   icon: "GridIcon",
      //   i18n: "AssessmentType"
      // },
      {
        url: "/Setting/CategoryAssessment",
        name: "CategoryAssessment",
        slug: "CategoryAssessment",
        icon: "GridIcon",
        i18n: "CustomerFeedbackCategory"
      },
      {
        url: "/Setting/ClassRoom",
        name: "ClassRoom",
        slug: "ClassRoom",
        icon: "GridIcon",
        i18n: "ClassRoom"
      },
      {
        url: "/Setting/ContactType",
        name: "ContactType",
        slug: "ContactType",
        icon: "GridIcon",
        i18n: "ContactType"
      },
      {
        url: "/Setting/Country",
        name: "Country",
        slug: "Country",
        icon: "GridIcon",
        i18n: "Country"
      },
      {
        url: "/Setting/CourseCategory",
        name: "CourseCategory",
        slug: "CourseCategory",
        icon: "GridIcon",
        i18n: "CourseCategory"
      },
      {
        url: "/Setting/CourseLevel",
        name: "Course Level",
        slug: "CourseLevel",
        icon: "GridIcon",
        i18n: "CourseLevel"
      },
      {
        url: "/Setting/CourseType",
        name: "Course Type",
        slug: "CourseType",
        icon: "GridIcon",
        i18n: "CourseType"
      },
      // {
      //   url: "/Setting/InstructorStatus",
      //   name: "InstructorStatus",
      //   slug: "InstructorStatus",
      //   icon: "GridIcon",
      //   i18n: "InstructorStatus"
      // },
      {
        url: "/Setting/Documentation",
        name: "Documentation",
        slug: "Documentation",
        icon: "GridIcon",
        i18n: "Documentation"
      },

      {
        url: "/Setting/EducationDegree",
        name: "EducationDegree",
        slug: "EducationDegree",
        icon: "GridIcon",
        i18n: "EducationDegree"
      },
      // {
      //   url: "/Setting/ExamType",
      //   name: "ExamType",
      //   slug: "ExamType",
      //   icon: "GridIcon",
      //   i18n: "ExamType"
      // },
      {
        url: "/Setting/Facility",
        name: "Facility",
        slug: "Facility",
        icon: "GridIcon",
        i18n: "Facility"
      },
      {
        url: "/Setting/GeneralImage",
        name: "GeneralImage",
        slug: "GeneralImage",
        icon: "GridIcon",
        i18n: "GeneralImage"
      },
      {
        url: "/Setting/GenerateCode",
        name: "Generate Code",
        slug: "GenerateCode",
        icon: "GridIcon",
        i18n: "GenerateCode"
      },
      {
        url: "/Setting/GeneralSetting",
        name: "GeneralSetting",
        slug: "GeneralSetting",
        icon: "GridIcon",
        i18n: "GeneralSetting"
      },
      {
        url: "/Setting/Language",
        name: "Language",
        slug: "Language",
        icon: "GridIcon",
        i18n: "Language"
      },

      {
        url: "/Setting/MaritalStatus",
        name: "MaritalStatus",
        slug: "MaritalStatus",
        icon: "GridIcon",
        i18n: "MaritalStatus"
      },
      {
        url: "/Setting/MaterialType",
        name: "MaterialType",
        slug: "MaterialType",
        icon: "GridIcon",
        i18n: "MaterialType"
      },
      {
        url: "/Setting/Nationality",
        name: "Nationality",
        slug: "Nationality",
        icon: "GridIcon",
        i18n: "Nationality"
      },
      {
        url: "/Setting/ParticipationType",
        name: "Participation Type ",
        slug: "ParticipationType",
        icon: "GridIcon",
        i18n: "ParticipationType"
      },
      {
        url: "/Setting/PaymentType",
        name: "Payment Type ",
        slug: "PaymentType",
        icon: "GridIcon",
        i18n: "PaymentType"
      },

      {
        url: "/Setting/PopulationList",
        name: "PopulationList",
        slug: "PopulationList",
        icon: "GridIcon",
        i18n: "PopulationList"
      },
      {
        url: "/Setting/ProposalStatus",
        name: "ProposalStatus  ",
        slug: "ProposalStatus",
        icon: "GridIcon",
        i18n: "ProposalStatus"
      },
      {
        url: "/Setting/ProposalTemplate",
        name: "ProposalTemplate  ",
        slug: "ProposalTemplate",
        icon: "GridIcon",
        i18n: "ProposalTemplate"
      },
      {
        url: "/Setting/Provider",
        name: "Provider",
        slug: "Provider",
        icon: "GridIcon",
        i18n: "Provider"
      },
      {
        url: "/Setting/QuestionLevel",
        name: "Question Level",
        slug: "QuestionLevel",
        icon: "GridIcon",
        i18n: "QuestionLevel"
      },
      {
        url: "/Setting/ReportManagement",
        name: "ReportManagement",
        slug: "ReportManagement",
        icon: "GridIcon",
        i18n: "ReportManagement"
      },
      {
        url: "/Setting/Room",
        name: "Room",
        slug: "Room",
        icon: "GridIcon",
        i18n: "RoomHotel"
      },
      {
        url: "/Setting/RoomFacility",
        name: "Room Facility",
        slug: "RoomFacility",
        icon: "GridIcon",
        i18n: "RoomHotelFacility"
      },
      {
        url: "/Setting/RoomType",
        name: "Room Type",
        slug: "RoomType",
        icon: "GridIcon",
        i18n: "RoomHotelType"
      },
      {
        url: "/RoomPrice",
        name: "RoomPrice",
        slug: "Room Price",
        icon: "GridIcon",
        i18n: "RoomHotelPrice",
      },
      // {
      //   url: "/Setting/QuestionType",
      //   name: "Question Type",
      //   slug: "QuestionType",
      //   icon: "GridIcon",
      //   i18n: "QuestionType"
      // },
      {
        url: "/Setting/MailTemplate",
        name: "MailTemplate  ",
        slug: "MailTemplate",
        icon: "GridIcon",
        i18n: "StatusMailTemplate"
      },
      {
        url: "/Setting/SystemMailTemplate",
        name: "SystemMailTemplate",
        slug: "SystemMailTemplate",
        icon: "GridIcon",
        i18n: "SystemMailTemplate"
      },
      {
        url: "/Setting/Status",
        name: "Status  ",
        slug: "Status",
        icon: "GridIcon",
        i18n: "Status"
      },

      {
        url: "/Setting/RequestLocation",
        name: "Request Location ",
        slug: "RequestLocation",
        icon: "GridIcon",
        i18n: "RequestLocation"
      },

      {
        url: "/Setting/TrainingStrategy",
        name: "TrainingStrategy  ",
        slug: "Training Strategy",
        icon: "GridIcon",
        i18n: "TrainingStrategy"
      },
      {
        url: "/Setting/UserTitle",
        name: "UserTitle  ",
        slug: "UserTitle",
        icon: "GridIcon",
        i18n: "UserTitle"
      }
    ]
  },
  // {
  //   url: "/DubaiEvent",
  //   name: "DubaiEvent",
  //   show:JSON.parse(localStorage.getItem("userInfo")).userRole=='admin',
  //   // tag: "2",
  //   // tagColor: "primary",
  //   slug: "DubaiEvent",
  //   icon: "AwardIcon",
  //   i18n: "Dubai Event",
  // },
]

